<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" slot="left" v-show="tabShow">
        <tab-tree :data="viewTreeData" @changeCompany="changeCompany" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
            <label style="margin-left:6px;">谐波：</label>
            <el-select style="width:150px;" v-model="harmonic">
              <el-option v-for="item in computedNum" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </time-search>
        </div>
        <div class="pane">
          <div class="echarts-warp">
            <div class="echart-content">
              <div class="echarts-title dn-title-bg">谐波频谱分析</div>
              <div class="lineEchart" id="echartsId" v-resize="resize"></div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="block">
            <span class="demonstration">选择时间段</span>
            <el-slider @change="changeslider(value2)" v-model="value2" :step="0.5" :max="24" show-stops :marks="marks"></el-slider>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import * as utils from "@/utils/index.js";
import TabTree from "@/components/common/TabTree.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import { findDataByParam } from "@/utils/index.js";
import dateTool from "@/utils/dateTool";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
];
export default {
  components: {
    TabTree,
    TimeSearch,
    BtnShow,
    ResizeContainer
  },
  computed: {
    marks () {
      let arr = [{ label: "总谐波", value: 0 }];
      for (let i = 2; i < 65; i++) {
        arr.push({
          label: "第" + this.toChinesNum(i) + "次谐波",
          value: i
        });
      }
      return arr;
    }
  },

  data () {
    return {
      viewTreeData: [],
      selectedDate: null,
      selectNode: [],
      tabShow: true,
      timeData: allTimeData,
      harmonic: 0,
      computedNum: [
        { value: 0, label: "电压" },
        { value: 1, label: "电流" }
      ],
      unit: "",
      myChart: null,
      title: "",
      titlename: "",
      value2: 0,
      marks: {}
    };
  },

  created () {
    let arr = [];
    for (let i = 0; i <= 24; i = i + 1) {
      arr.push(i);
    }
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
      obj[i] = arr[i] + "";
    }
    this.marks = obj;
  },
  methods: {
    /* 图表重加载 */
    resize () {
      let vm = this;
      if (vm.myChart) {
        vm.myChart.resize();
      }
    },
    toChinesNum (num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
      ];
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = temp => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
                ? ""
                : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) {
        noWan = "0" + noWan;
      }
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
    changeCompany (companyId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/analysis/spectrumAnalysis", null)
        .then(res => {
          if (!res) return;
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          vm.viewTreeData = viewTreeData;
        });
    },
    /* 树默认加载 */
    tabTreeDefault (node) {
      let vm = this;
      let dataType = vm.dataType;
      vm.selectNodes = JSON.parse(JSON.stringify(node));
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
      time.setDate(time.getDate() + 1);
      let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
      vm.selectedDate = {
        dataType: "1",
        dateType: "day",
        endTime: endTime,
        startTime: startTime,
      };
      vm.getData();
    },
    /* 树点击事件 */
    tabTreeClick (e) {
      let vm = this;
      vm.selectNodes = e;
      vm.getData();
    },
    /* 查询事件 */
    TimeControlClick (e) {
      let vm = this;
      vm.selectedDate = e;
      vm.value2 = 0;
      vm.getData();
    },
    timeControlChange (e) { },
    /* 调取接口获取数据 */
    getData () {
      let vm = this;
      let HARMONIC = [
        { harmonic: '1', data: [10000, 15000, 20000] }, /* 谐波电压 */
        { harmonic: '2', data: [25000, 30000, 35000] }, /* 谐波电流 */
      ]
      let harmonicData = [[], [], []] /* 存放谐波测量点 */
      const element = vm.selectNodes;
      for (let i = 2; i <= 64; i++) {
        for (let j = 0; j < 3; j++) {
          harmonicData[j].push({
            measureId: element.measureId,
            pointNumber: 0,
            pointCode: HARMONIC[vm.harmonic].data[j] + i
          })
        }
      }
      if (vm.harmonic == 0) {
        vm.titlename = vm.selectNodes.measureName + "-电压谐波频谱";
      } else {
        vm.titlename = vm.selectNodes.measureName + " -电流谐波频谱";
      }
      vm.title = [
        "A相(" + vm.selectNodes.measureName + ")",
        "B相(" + vm.selectNodes.measureName + ")",
        "C相(" + vm.selectNodes.measureName + ")"
      ];
      vm.getQuantityData(harmonicData);
    },
    getQuantityData (harmonicData) {
      let vm = this;
      let arr = [];
      harmonicData.map(item => {
        arr.push(
          vm.$api.measuring.getMeasuringValueAll2(
            item,
            vm.selectedDate.startTime,
            vm.selectedDate.endTime,
            0,
            1
          )
        );
      })
      Promise.all(arr).then(res => {
        let dataone = vm.checkData(res[0]);
        let datatwo = vm.checkData(res[1]);
        let datatree = vm.checkData(res[2]);
        let obj = {
          title: vm.titlename,
          legend: vm.title,
          dataone: dataone,
          datatwo: datatwo,
          datatree: datatree,
          length: []
        };
        for (let i = 2; i <= 64; i++) {
          obj.length.push(i);
        }
        vm.getEchart(obj);
      });
    },
    changeslider (e) {
      let time = this.selectedDate.startTime.slice(0, 10);
      switch (e) {
        case 0:
          this.selectedDate.startTime = time + " 00:00:00";
          this.getData();
          break;
        case 0.5:
          this.selectedDate.startTime = time + " 00:30:00";
          this.getData();
          break;
        case 1:
          this.selectedDate.startTime = time + " 01:00:00";
          this.getData();
          break;
        case 1.5:
          this.selectedDate.startTime = time + " 01:30:00";
          this.getData();
          break;
        case 2:
          this.selectedDate.startTime = time + " 02:00:00";
          this.getData();
          break;
        case 2.5:
          this.selectedDate.startTime = time + " 02:30:00";
          this.getData();
          break;
        case 3:
          this.selectedDate.startTime = time + " 03:00:00";
          this.getData();
          break;
        case 3.5:
          this.selectedDate.startTime = time + " 03:30:00";
          this.getData();
          break;
        case 4:
          this.selectedDate.startTime = time + " 04:00:00";
          this.getData();
          break;
        case 4.5:
          this.selectedDate.startTime = time + " 04:30:00";
          this.getData();
          break;
        case 5:
          this.selectedDate.startTime = time + " 05:00:00";
          this.getData();
          break;
        case 5.5:
          this.selectedDate.startTime = time + " 05:30:00";
          this.getData();
          break;
        case 6:
          this.selectedDate.startTime = time + " 06:00:00";
          this.getData();
          break;
        case 6.5:
          this.selectedDate.startTime = time + " 06:30:00";
          this.getData();
          break;
        case 7:
          this.selectedDate.startTime = time + " 07:00:00";
          this.getData();
          break;
        case 7.5:
          this.selectedDate.startTime = time + " 07:30:00";
          this.getData();
          break;
        case 8:
          this.selectedDate.startTime = time + " 08:00:00";
          this.getData();
          break;
        case 8.5:
          this.selectedDate.startTime = time + " 08:30:00";
          this.getData();
          break;
        case 9:
          this.selectedDate.startTime = time + " 09:00:00";
          this.getData();
          break;
        case 9.5:
          this.selectedDate.startTime = time + " 09:30:00";
          this.getData();
          break;
        case 10:
          this.selectedDate.startTime = time + " 10:00:00";
          this.getData();
          break;
        case 10.5:
          this.selectedDate.startTime = time + " 10:30:00";
          this.getData();
          break;
        case 11:
          this.selectedDate.startTime = time + " 11:00:00";
          this.getData();
          break;
        case 11.5:
          this.selectedDate.startTime = time + " 11:30:00";
          this.getData();
          break;
        case 12:
          this.selectedDate.startTime = time + " 12:00:00";
          this.getData();
          break;
        case 12.5:
          this.selectedDate.startTime = time + " 12:30:00";
          this.getData();
          break;
        case 13:
          this.selectedDate.startTime = time + " 13:00:00";
          this.getData();
          break;
        case 13.5:
          this.selectedDate.startTime = time + " 13:30:00";
          this.getData();
          break;
        case 14:
          this.selectedDate.startTime = time + " 14:00:00";
          this.getData();
          break;
        case 14.5:
          this.selectedDate.startTime = time + " 14:30:00";
          this.getData();
          break;
        case 15:
          this.selectedDate.startTime = time + " 15:00:00";
          this.getData();
          break;
        case 15.5:
          this.selectedDate.startTime = time + " 15:30:00";
          this.getData();
          break;
        case 16:
          this.selectedDate.startTime = time + " 16:00:00";
          this.getData();
          break;
        case 16.5:
          this.selectedDate.startTime = time + " 16:30:00";
          this.getData();
          break;
        case 17:
          this.selectedDate.startTime = time + " 17:00:00";
          this.getData();
          break;
        case 17.5:
          this.selectedDate.startTime = time + " 17:30:00";
          this.getData();
          break;
        case 18:
          this.selectedDate.startTime = time + " 18:00:00";
          this.getData();
          break;
        case 18.5:
          this.selectedDate.startTime = time + " 18:30:00";
          this.getData();
          break;
        case 19:
          this.selectedDate.startTime = time + " 19:00:00";
          this.getData();
          break;
        case 19.5:
          this.selectedDate.startTime = time + " 19:30:00";
          this.getData();
          break;
        case 20:
          this.selectedDate.startTime = time + " 20:00:00";
          this.getData();
          break;
        case 20.5:
          this.selectedDate.startTime = time + " 20:30:00";
          this.getData();
          break;
        case 21:
          this.selectedDate.startTime = time + " 21:00:00";
          this.getData();
          break;
        case 21.5:
          this.selectedDate.startTime = time + " 21:30:00";
          this.getData();
          break;
        case 22:
          this.selectedDate.startTime = time + " 22:00:00";
          this.getData();
          break;
        case 22.5:
          this.selectedDate.startTime = time + " 22:30:00";
          this.getData();
          break;
        case 23:
          this.selectedDate.startTime = time + " 23:00:00";
          this.getData();
          break;
        case 23.5:
          this.selectedDate.startTime = time + " 23:30:00";
          this.getData();
          break;
        case 24:
          this.selectedDate.startTime = time + " 23:59:00";
          this.getData();
          break;
      }
      /*  */
    },

    getEchart (obj) {
      let this_ = this;
      this.myChart = this.$echarts.init(document.getElementById("echartsId"));
      var option = {
        title: {
          text: obj.title,
          left: "center"
        },
        grid: {
          x: 50,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10
        },

        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: obj.legend,
          top: "6%",
          icon: "line"
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center"
          }
        ],
        toolbox: {
          show: true,
          feature: {
            // dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            // restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        calculable: true,
        color: ["#00AAFF", "#52CCA3", "#CCCC00", "#E62E4D", "#8673E6"],
        xAxis: [
          {
            type: "category",
            data: obj.length
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "%"
          }
        ],
        series: [
          {
            name: obj.legend[0],
            type: "bar",
            data: obj.dataone
          },
          {
            name: obj.legend[1],
            type: "bar",
            data: obj.datatwo
          },
          {
            name: obj.legend[2],
            type: "bar",
            data: obj.datatree
          }
        ]
      };

      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function () {
          this_.myChart.resize();
        });
      }
    },
    //处理数据
    checkData (e) {
      let data = e.data;
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].data.data.length == []) {
          arr.push("-");
        } else {
          for (let j = 0; j < data[i].data.data.length; j++) {
            arr.push((data[i].data.data[j].value).toFixed(2));
          }
        }
      }
      return arr;
    }
  }
};
</script>
<style scoped>
.dqyxfx-warp {
  /* width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden; */
  color: #000;
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.left-content {
  /* width: 14%;
  background: #ffffff; */
  height: 100%;
  width: 100%;
  margin-right: 14px;
}
.right-content {
  /* overflow: hidden;
  flex: 1;
  display: flex;
  flex-flow: column;
  margin-left: 16px; */
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
.top {
  height: 40px;
  line-height: 40px;
}
.top ul {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
}
.top ul li {
  float: left;
  font-size: 16px;
  margin-left: 20px;
}
.top ul li:first-child {
  margin-left: 0px;
}
.red {
  color: #ed6a93;
}
.pane {
  padding: 14px 0px;
  overflow: auto;
}
.echarts-warp {
  width: 100%;
  padding: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #dedcdc;
  /* margin-bottom: 14px; */
}
.echart-content {
  border-radius: 5px;
  border: 1px solid #dedcdc;
  overflow: hidden;
  position: relative;
}
.lineEchart {
  background: #fff;
  width: 100%;
  height: 400px;
  /* overflow: hidden; */
}
.bottom {
  padding: 20px 0px;
  overflow: auto;
  background: #fff;
  height: 80px;
  border-radius: 5px;
  border: 1px solid #dedcdc;
  /* display: flex;
  justify-content: center; */
}
.block {
  width: 90%;
  margin-left: 5%;
}
.echarts-title {
  height: 34px;
  text-align: left;
  line-height: 34px;
  padding-left: 14px;
  color: #fff;
}

@media screen and (max-width: 1440px) {
  .tab-pane {
    height: 480px;
    overflow-y: auto;
  }
}
.theme-defalt .dn-title-bg {
  background: #fff;
}
</style>